import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Fragment } from 'react';

// material-ui
import { Box, List, Typography } from '@mui/material';

// project import
import NavItem from './NavItem';

const NavGroup = ({ item, level }) => {
    const menu = useSelector((state) => state.menu);
    const credentials = useSelector((state) => state.session.credentials);

    const { drawerOpen } = menu;

    const navCollapse = item.children?.map((menuItem) => {
        switch (menuItem.type) {
            case 'collapse':
                if (item?.secure && !credentials.menu_permissions[item.id]) {
                    return <Fragment key={menuItem.id} />;
                }

                if (item?.experimental && process.env['REACT_APP_ENV'] === 'prod') {
                    return <Fragment key={menuItem.id} />;
                }

                return (
                    <NavItem key={menuItem.id} item={menuItem} level={level}>
                        <NavGroup key={menuItem.id} item={menuItem} level={level + 1} />
                    </NavItem>
                );
            case 'item':
                return <NavItem key={menuItem.id} item={menuItem} level={level} />;
            default:
                return (
                    <Typography key={menuItem.id} variant="h6" color="error" align="center">
                        Fix - Group Collapse or Items
                    </Typography>
                );
        }
    });

    return (
        <List
            subheader={
                level === 1 &&
                item.title &&
                drawerOpen && (
                    <Box sx={{ pl: 3, mb: 1.5 }}>
                        <Typography variant="subtitle2" color="textSecondary">
                            {item.title}
                        </Typography>
                    </Box>
                )
            }
            sx={{ mb: drawerOpen ? 1.5 : 0, py: 0, zIndex: 0 }}
        >
            {navCollapse}
        </List>
    );
};

NavGroup.propTypes = {
    item: PropTypes.object,
    level: PropTypes.number
};

NavGroup.defaultProps = {
    level: 1
};

export default NavGroup;
